// src/apis/careerAPI.js
import { requestApi } from "./axiosHelper";

const rootUrl = process.env.NODE_ENV
  ? process.env.REACT_APP_API_ROOT_URL
  : "http://localhost:8000/api/v1";

const careerEP = rootUrl + "/career";

const careerAPI = {
  // ✅ Create a new career
  createNewCareer: async (obj) => {
    try {
      const axiosData = {
        url: `${careerEP}/create`,
        method: "post",
        data: obj,
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  // ✅ Fetch all careers or by ID
  fetchCareers: async (_id) => {
    try {
      const axiosData = {
        url: _id ? `${careerEP}/${_id}` : careerEP,
        method: "get",
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  // ✅ Fetch careers by filters (status, location, type)
  fetchByFilters: async (params) => {
    try {
      const axiosData = {
        url: `${careerEP}?${params}`,
        method: "get",
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  // ✅ Update a career by ID
  updateCareer: async (_id, obj) => {
    try {
      const axiosData = {
        url: `${careerEP}/edit/${_id}`,
        method: "patch",
        data: obj,
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },

  // ✅ Delete a career by ID
  deleteCareer: async (_id) => {
    try {
      const axiosData = {
        url: `${careerEP}/${_id}`,
        method: "delete",
      };
      const data = await requestApi(axiosData, true);
      return data;
    } catch (error) {
      return (
        error.response?.data || { status: "error", message: error.message }
      );
    }
  },
};

export default careerAPI;
